import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { VigilantGuard } from './guards/vigilant.guard';
import { NewsComponent } from './components/news/news.component';
import { MeetingComponent } from './components/meeting/meeting.component';
import { PublicationComponent } from './components/publication/publication.component';
import { PublicationDetailComponent } from './components/publication/publication-detail/publication-detail.component';
import { NetworksComponent } from './components/networks/networks.component';
import { ForosFuturoComponent } from './components/foros-futuro/foros-futuro.component';
import { ForoDetalleComponent } from './components/foros-futuro/foro-detalle/foro-detalle.component';
import { SceneComponent } from './components/scene/scene.component';
import { RadarComponent } from './components/radar/radar.component';
import { PodcastsComponent } from './components/podcasts/podcasts.component';
import { FichaComponent } from './components/shared/ficha/ficha.component';
import { TrendsComponent } from './components/trends/trends.component';
import { GlobalComponent } from './components/trends/global/global.component';
import { NationalComponent } from './components/trends/national/national.component';
import { TerritorialComponent } from './components/trends/territorial/territorial.component';
import { SectorialComponent } from './components/trends/sectorial/sectorial.component';
import { TSECTORIAL_ROUTES } from './components/trends/sectorial/sectorial.routes';
import { RiskComponent } from './components/risk/risk.component';
import { TerritorialesComponent } from './components/risk/territoriales/territoriales.component';
import { GlobalesComponent } from './components/risk/globales/globales.component';
import { OppComponent } from './components/opp/opp.component';
import { GlobalopComponent } from './components/opp/globalop/globalop.component';
import { TerritorialopComponent } from './components/opp/territorialop/territorialop.component';
import { MegaComponent } from './components/mega/mega.component';
import { ForcemapComponent } from './components/forcemap/forcemap.component';
import { SearchResultComponent } from './components/util/search/search-global/search-result/search-result.component';
import { AdmComponent } from './components/adm/adm.component';
import { ADM_ROUTES } from './components/adm/adm.routes';
import { HeaderSurveyComponent } from './components/survey/header-survey/header-survey.component';
import { InvestigationComponent } from './components/survey/investigation/investigation.component';
import { PreviewComponent } from './components/survey/preview/preview.component';
import { TestpreviewComponent } from './components/survey/testpreview/testpreview.component';
import { ExternalsurveyComponent } from './components/survey/externalsurvey/externalsurvey.component';
import { VigilantSurveyGuard } from './guards/vigilant-survey.guard';
import { SURVEY_ROUTES } from './components/survey/survey.routes';
import { FichaTestComponent } from './components/shared/ficha-test/ficha-test.component';
import { FichaHistorialComponent } from './components/shared/ficha-historial/ficha-historial.component';

const routes: Routes = [
  { path: 'inicio', component: HomeComponent },
  { path: 'actualidad/:id', component: NewsComponent },
  { path: 'encuentro/:id', component: MeetingComponent },
  { path: 'publicacion', component: PublicationComponent },
  { path: 'publicacion/filtro/:tem/:id', component: PublicationComponent },
  { path: 'publicacion/detalle/:id', component: PublicationDetailComponent },
  { path: 'redes', component: NetworksComponent },
  { path: 'forosdelfuturo', component: ForosFuturoComponent },
  { path: 'forosdelfuturo/foro-detalle/:id', component: ForoDetalleComponent },
  { path: 'escenario', component: SceneComponent },
  { path: 'evento', component: RadarComponent },
  { path: 'podcast', component: PodcastsComponent },
  { path: 'ficha/:id', component: FichaComponent },  
  { path: 'ficha-test/:id', component: FichaTestComponent, canActivate: [VigilantGuard] },
  { path: 'ficha-historial/:id', component: FichaHistorialComponent, canActivate: [VigilantGuard] },
  /*-------------------------------------------------------------------------*/
  { path: 'tendencia', component: TrendsComponent },
  { path: 'tendencia-global', component: GlobalComponent },
  { path: 'tendencia-nacional', component: NationalComponent },
  { path: 'tendencia-territorial', component: TerritorialComponent },
  { path: 'tendencia-sectorial', component: SectorialComponent, children: TSECTORIAL_ROUTES },
  { path: 'riesgo', component: RiskComponent },
  { path: 'riesgo-territorial', component: TerritorialesComponent },
  { path: 'riesgo-global', component: GlobalesComponent },
  { path: 'oportunidad', component: OppComponent },
  { path: 'oportunidad-global', component: GlobalopComponent },
  { path: 'oportunidad-territorial', component: TerritorialopComponent },
  { path: 'megatendencia', component: MegaComponent },
  { path: 'mapas', component: ForcemapComponent },
  /*-------------------------------------------------------------------------*/
  { path: 'adm', component: AdmComponent, canActivateChild: [VigilantGuard], children: ADM_ROUTES },
  /*-------------------------------------------------------------------------*/
  { path: 'encuesta', component: HeaderSurveyComponent, canActivateChild: [VigilantSurveyGuard], children: SURVEY_ROUTES },
  { path: 'investigacion/:url', component: InvestigationComponent },
  { path: 'investigacion/:id', component: InvestigationComponent },
  { path: 'investigacion/:url/:email', component: InvestigationComponent },
  { path: 'investigacion/:id/:email', component: InvestigationComponent },
  { path: 'preview/:url', component: PreviewComponent },
  { path: 'testpreview/:url', component: TestpreviewComponent },
  { path: 'encuesta-externa/:url', component: ExternalsurveyComponent },
  { path: 'encuesta-oportunidades-2022', component: ExternalsurveyComponent },
  /*-------------------------------------------------------------------------- */
  { path: 'search-results-list', component: SearchResultComponent },
  { path: 'login', component: LoginComponent, canActivateChild: [VigilantGuard] },
  { path: '**', pathMatch: 'full', redirectTo: 'inicio' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
